export const updateCSSVariables = () => {
  document.documentElement.style.setProperty(
    '--env-background-color',
    process.env.REACT_APP_BACKGROUND_COLOR
  );
};